










import {
  Component,
  Prop,
  Vue
} from 'vue-property-decorator';
import { ApiService } from '@/services/ApiService';
import { OrderTemplatesApi } from '@eurogast/hub-client-typescript';
import { ConfigService } from '@/services/ConfigService';
import ConfirmationActionButton from '@/common/ConfirmationActionButton.vue';
import MatomoEvents from '@/matomo/events/MatomoEvents';

@Component({
  components: {ConfirmationActionButton}
})
export default class OrderTemplateDeleteButton extends Vue {
  @Prop()
  public localOrderTemplateId: string;

  get orderTemplateId(): number {
    return parseInt(this.localOrderTemplateId, 0);
  }

  public deleteOrderTemplate() {
    MatomoEvents.forOrderTemplates.removeTemplate.publish();
    ApiService.wrap(OrderTemplatesApi)
        .removeOrderTemplate(ConfigService.getTenant(),
            this.orderTemplateId,
            ConfigService.currentCustomerId)
        .then(() => window.location.href = '/my/ordertemplates')
        .catch(ApiService.defaultErrorHandler);
  }
}
